import { Base } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { Flip } from 'gsap/Flip';

/**
 * Homepage class.
 */
export default class Texts extends Base {
  /**
   * Class config
   * @type {Object}
   */
  static config = {
    name: 'Texts',
    emits: ['text-transition-finished'],
    refs: ['container[]', 'destination', 'start', 'btn[]'],
  };

  /**
   * Mount component
   * @returns {void}
   */
  mounted() {
    gsap.registerPlugin(Flip);
    this.current = null;
    this.animated = false;
    this.$refs.container.forEach((element) => {
      const content = element.querySelector('.text__content');
      content.style.display = 'none';
    });
  }

  /**
   * Click on title
   * @param  {Object} e
   * @returns {void}
   */
  onBtnClick(e) {
    this.current = e.currentTarget.parentNode;
    this.current.classList.add('current');

    this.state = Flip.getState(this.current);

    this.tl = gsap.timeline({
      onComplete: this.animated ? this.closeContent() : this.openContent(),
    });

    this.$refs.container.forEach((element) => {
      if (element !== this.current) {
        this.tl.to(element, {
          opacity: 0,
          ease: 'power1.inOut',
          duration: 0,
        });
      }
    });
  }

  /**
   * Open content
   * @returns {void}
   */
  openContent() {
    this.$refs.destination.append(this.current);
    Flip.from(this.state, {
      scale: false,
      duration: 1,
      ease: '0.25,0.1,0.25,1',
      onComplete: () => {
        const content = this.current.querySelector('.text__content');
        content.style.position = 'relative';
        this.$refs.start.style.display = 'none';

        gsap.to(content, {
          opacity: 1,
          display: 'block',
          ease: '0.25,0.1,0.25,1',
        });

        this.animated = true;
      },
    });
  }

  /**
   * Close content
   * @returns {void}
   */
  closeContent() {
    const content = this.current.querySelector('.text__content');
    gsap
      .to(content, {
        opacity: 0,
        ease: '0.25,0.1,0.25,1',
        display: 'none',
      })
      .then(() => {
        this.$refs.start.style.display = 'block';
        const { position } = this.current.dataset;
        this.$refs.start.insertBefore(this.current, this.$refs.start.children[position - 1]);

        this.$refs.container.forEach((element) => {
          if (element !== this.current) {
            element.style.display = 'block';
          }
        });

        Flip.from(this.state, {
          scale: false,
          duration: 1,
          ease: '0.25,0.1,0.25,1',
          onComplete: () => {
            this.animated = false;
            const otherTexts = [];
            this.$refs.container.forEach((element) => {
              if (element !== this.current) {
                otherTexts.push(element);
              }
            });
            gsap
              .to(otherTexts, {
                duration: 1,
                opacity: 1,
                ease: '0.25,0.1,0.25,1',
              })
              .then(() => {
                this.$emit(
                  'text-transition-finished',
                  this.current.querySelector('[data-component="LargeText"]')
                );
              });
          },
        });
      });
  }
}
